import { render, staticRenderFns } from "./SandboxView.vue?vue&type=template&id=5dc56247&scoped=true&"
import script from "./SandboxView.vue?vue&type=script&lang=js&"
export * from "./SandboxView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc56247",
  null
  
)

export default component.exports